import Icon from '../components/Icon.vue'

Icon.register({"superpowers":{"width":1792,"height":1792,"paths":[{"d":"M1473 929q7-118-33-226.5t-113-189-177-131-221-57.5q-116-7-225.5 32t-192 110.5-135 175-59.5 220.5q-7 118 33 226.5t113 189 177.5 131 221.5 57.5q155 9 293-59t224-195.5 94-283.5zM1792 0l-349 348q120 117 180.5 272t50.5 321q-11 183-102 339t-241 255.5-332 124.5l-999 132 347-347q-120-116-180.5-271.5t-50.5-321.5q11-184 102-340t241.5-255.5 332.5-124.5q167-22 500-66t500-66z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/superpowers.js
// module id = 1459
// module chunks = 0